import React, { useState } from "react";
import ManagerDashboardWapper from "../../../layout/wrapper/ManagerDashboardWapper";
import {
    Box,
    Grid,
    List,
    ListItem,
    Paper,
    Stack,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Tabs,
    Typography,
} from "@mui/material";
import styles from "../../../styles/pages/user/managerdashboard/manager-dashboard.module.scss";
import PropTypes from "prop-types";
import MgTabpendingreviewIcon from "../../../ui/Icons/MgTabpendingreviewIcon";
import MgTabinquiryIcon from "../../../ui/Icons/MgTabinquiryIcon";
import MgTabmessageIcon from "../../../ui/Icons/MgTabmessageIcon";
import DataCalender from "../../../components/DataCalender/DataCalender";
import LongArrowIcon from "../../../ui/Icons/LongArrowIcon";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { usePost } from "../../../hooks/api/useFetch";
import { parseCookies } from "nookies";
import MenuReviewedVdoIcon from "../../../ui/Icons/MenuReviewedVdoIcon";
import MenuVerifiedVdoIcon from "../../../ui/Icons/MenuVerifiedVdoIcon";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export default function ManagerDashboard() {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const cookies = parseCookies();
    const userData = JSON.parse(cookies?.userdetails || "{}");

    const [dateSelected, setDateSelected] = useState({ from: "", to: "" });

    const {
        data: managerSubmissionsData,
        isLoading: managerSubmissionsIsLoading,
        isSuccess: managerSubmissionsIsSuccess,
    } = usePost(
        ["manager-submissions", userData?.id, dateSelected],
        "manager/submissions",
        {
            from: dateSelected.from,
            to: dateSelected.to,
            user_id: userData.id,
        }
    );

    return (
        <>
            <ManagerDashboardWapper>
                <Paper elevation={0} className={styles.pageManager}>
                    <Box className={styles.groupTabBtn}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="basic tabs example"
                        >
                            <Tab
                                label={
                                    <>
                                        <Stack
                                            direction={"row"}
                                            alignItems={"center"}
                                            flexWrap={"wrap"}
                                            className={`${styles.tabBtnWrapper} ${styles.tabBtnPending}`}
                                        >
                                            <figure>
                                                <MgTabpendingreviewIcon />
                                            </figure>
                                            <Box
                                                className={styles.tablabelRight}
                                            >
                                                <Typography variant="body2">
                                                    Pending Review
                                                </Typography>
                                                <Typography variant="caption">
                                                    {managerSubmissionsData
                                                        ?.data?.data
                                                        ?.submissions?.pending
                                                        ? managerSubmissionsData
                                                            ?.data?.data
                                                            ?.submissions
                                                            ?.pending
                                                        : "-"}
                                                </Typography>
                                            </Box>
                                        </Stack>
                                    </>
                                }
                                {...a11yProps(0)}
                            />
                            <Tab
                                label={
                                    <>
                                        <Stack
                                            direction={"row"}
                                            alignItems={"center"}
                                            flexWrap={"wrap"}
                                            className={`${styles.tabBtnWrapper} ${styles.tabBtnInquiring}`}
                                        >
                                            <figure>
                                                <MgTabinquiryIcon />
                                            </figure>
                                            <Box
                                                className={styles.tablabelRight}
                                            >
                                                <Typography variant="body2">
                                                    Inquiring Videos
                                                </Typography>
                                                <Typography variant="caption">
                                                    {managerSubmissionsData
                                                        ?.data?.data
                                                        ?.submissions?.inquiry
                                                        ? managerSubmissionsData
                                                            ?.data?.data
                                                            ?.submissions
                                                            ?.inquiry
                                                        : "-"}
                                                </Typography>
                                            </Box>
                                        </Stack>
                                    </>
                                }
                                {...a11yProps(1)}
                            />
                            <Tab
                                label={
                                    <>
                                        <Stack
                                            direction={"row"}
                                            alignItems={"center"}
                                            flexWrap={"wrap"}
                                            className={`${styles.tabBtnWrapper} ${styles.tabBtnReview}`}
                                        >
                                            <figure>
                                                {/* <MgTabreviewedIcon /> */}
                                                <MenuReviewedVdoIcon />
                                            </figure>
                                            <Box
                                                className={styles.tablabelRight}
                                            >
                                                <Typography variant="body2">
                                                    Reviewed Videos{" "}
                                                    <span>
                                                        (Pending Verification)
                                                    </span>
                                                </Typography>
                                                <Typography variant="caption">
                                                    {managerSubmissionsData
                                                        ?.data?.data
                                                        ?.submissions?.reviewed
                                                        ? managerSubmissionsData
                                                            ?.data?.data
                                                            ?.submissions
                                                            ?.reviewed
                                                        : "-"}
                                                </Typography>
                                            </Box>
                                        </Stack>
                                    </>
                                }
                                {...a11yProps(2)}
                            />
                            <Tab
                                label={
                                    <>
                                        <Stack
                                            direction={"row"}
                                            alignItems={"center"}
                                            flexWrap={"wrap"}
                                            className={`${styles.tabBtnWrapper} ${styles.tabBtnVerified}`}
                                        >
                                            <figure>
                                                {/* <MgTabverifiedIcon /> */}
                                                <MenuVerifiedVdoIcon />
                                            </figure>
                                            <Box
                                                className={styles.tablabelRight}
                                            >
                                                <Typography variant="body2">
                                                    Verified Videos
                                                </Typography>
                                                <Typography variant="caption">
                                                    {managerSubmissionsData
                                                        ?.data?.data
                                                        ?.submissions?.verified
                                                        ? managerSubmissionsData
                                                            ?.data?.data
                                                            ?.submissions
                                                            ?.verified
                                                        : "-"}
                                                </Typography>
                                            </Box>
                                        </Stack>
                                    </>
                                }
                                {...a11yProps(3)}
                            />
                            <Tab
                                label={
                                    <>
                                        <Stack
                                            direction={"row"}
                                            alignItems={"center"}
                                            flexWrap={"wrap"}
                                            className={`${styles.tabBtnWrapper} ${styles.tabBtnMsg}`}
                                        >
                                            <figure>
                                                <MgTabmessageIcon />
                                            </figure>
                                            <Box
                                                className={styles.tablabelRight}
                                            >
                                                <Typography variant="body2">
                                                    Open Messages
                                                </Typography>
                                                <Typography variant="caption">
                                                    {managerSubmissionsData
                                                        ?.data?.data
                                                        ?.submissions
                                                        ?.open_message
                                                        ? managerSubmissionsData
                                                            ?.data?.data
                                                            ?.submissions
                                                            ?.open_message
                                                        : "-"}
                                                </Typography>
                                            </Box>
                                        </Stack>
                                    </>
                                }
                                {...a11yProps(4)}
                            />
                        </Tabs>
                    </Box>
                </Paper>
                <Box className={styles.managerTabsPanel}>
                    <CustomTabPanel value={value} index={0}>
                        <Paper elevation={0} className={styles.pageManager}>
                            <PerfectScrollbar
                                className={styles.managerDashboardScroll}
                            >
                                <DataCalender
                                    dateSelected={dateSelected}
                                    setDateSelected={setDateSelected}
                                />
                                <Box className={styles.dashboardVdoboxMain}>
                                    <Grid
                                        container
                                        columnSpacing={3}
                                        rowSpacing={3}
                                    >
                                        <Grid item lg={4}>
                                            <Box
                                                className={`${styles.reviewVdoBox} ${styles.colBox}`}
                                            >
                                                <Stack
                                                    direction={"row"}
                                                    flexWrap={"wrap"}
                                                    alignItems={"center"}
                                                    justifyContent={
                                                        "space-between"
                                                    }
                                                    className={
                                                        styles.vdoBoxHeader
                                                    }
                                                >
                                                    <Typography variant="h3">
                                                        Reviewed Videos
                                                    </Typography>
                                                    <Typography variant="caption">
                                                        {managerSubmissionsData
                                                            ?.data?.data
                                                            ?.submissions
                                                            ?.reviewed
                                                            ? managerSubmissionsData
                                                                ?.data?.data
                                                                ?.submissions
                                                                ?.reviewed
                                                            : "-"}
                                                    </Typography>
                                                </Stack>
                                                <List disablePadding>
                                                    <ListItem>
                                                        <Grid
                                                            container
                                                            spacing={0}
                                                        >
                                                            <Grid item lg={9}>
                                                                <Typography variant="body1">
                                                                    Approved
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item lg={3}>
                                                                <Typography
                                                                    variant="body1"
                                                                    sx={{
                                                                        textAlign:
                                                                            "right",
                                                                    }}
                                                                >
                                                                    {managerSubmissionsData
                                                                        ?.data
                                                                        ?.data
                                                                        ?.reviewed_videos
                                                                        ?.approved
                                                                        ? managerSubmissionsData
                                                                            ?.data
                                                                            ?.data
                                                                            ?.reviewed_videos
                                                                            ?.approved
                                                                        : "-"}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </ListItem>
                                                    <ListItem>
                                                        <Grid
                                                            container
                                                            spacing={0}
                                                        >
                                                            <Grid item lg={9}>
                                                                <Typography variant="body1">
                                                                    Rejected
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item lg={3}>
                                                                <Typography
                                                                    variant="body1"
                                                                    sx={{
                                                                        textAlign:
                                                                            "right",
                                                                    }}
                                                                >
                                                                    {managerSubmissionsData
                                                                        ?.data
                                                                        ?.data
                                                                        ?.reviewed_videos
                                                                        ?.rejected
                                                                        ? managerSubmissionsData
                                                                            ?.data
                                                                            ?.data
                                                                            ?.reviewed_videos
                                                                            ?.rejected
                                                                        : "-"}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </ListItem>
                                                    <ListItem>
                                                        <Grid
                                                            container
                                                            spacing={0}
                                                        >
                                                            <Grid item lg={9}>
                                                                <Typography variant="body1">
                                                                    Website Only
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item lg={3}>
                                                                <Typography
                                                                    variant="body1"
                                                                    sx={{
                                                                        textAlign:
                                                                            "right",
                                                                    }}
                                                                >
                                                                    {managerSubmissionsData
                                                                        ?.data
                                                                        ?.data
                                                                        ?.reviewed_videos
                                                                        ?.website_only
                                                                        ? managerSubmissionsData
                                                                            ?.data
                                                                            ?.data
                                                                            ?.reviewed_videos
                                                                            ?.website_only
                                                                        : "-"}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </ListItem>
                                                    <ListItem>
                                                        <Grid
                                                            container
                                                            spacing={0}
                                                        >
                                                            <Grid item lg={9}>
                                                                <Typography variant="body1">
                                                                    Duplicates
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item lg={3}>
                                                                <Typography
                                                                    variant="body1"
                                                                    sx={{
                                                                        textAlign:
                                                                            "right",
                                                                    }}
                                                                >
                                                                    {managerSubmissionsData
                                                                        ?.data
                                                                        ?.data
                                                                        ?.reviewed_videos
                                                                        ?.duplicate
                                                                        ? managerSubmissionsData
                                                                            ?.data
                                                                            ?.data
                                                                            ?.reviewed_videos
                                                                            ?.duplicate
                                                                        : "-"}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </ListItem>
                                                </List>
                                            </Box>
                                            <Box
                                                className={`${styles.verifiedVdoBox} ${styles.colBox}`}
                                            >
                                                <Stack
                                                    direction={"row"}
                                                    flexWrap={"wrap"}
                                                    alignItems={"center"}
                                                    justifyContent={
                                                        "space-between"
                                                    }
                                                    className={
                                                        styles.vdoBoxHeader
                                                    }
                                                >
                                                    <Typography variant="h3">
                                                        Verified Videos
                                                    </Typography>
                                                    <Typography variant="caption">
                                                        {managerSubmissionsData
                                                            ?.data?.data
                                                            ?.submissions
                                                            ?.verified
                                                            ? managerSubmissionsData
                                                                ?.data?.data
                                                                ?.submissions
                                                                ?.verified
                                                            : "-"}
                                                    </Typography>
                                                </Stack>
                                            </Box>
                                        </Grid>
                                        <Grid item lg={4}>
                                            <Box
                                                className={`${styles.confirmVdoBox} ${styles.colBox}`}
                                            >
                                                <Stack
                                                    direction={"row"}
                                                    flexWrap={"wrap"}
                                                    alignItems={"center"}
                                                    justifyContent={
                                                        "space-between"
                                                    }
                                                    className={
                                                        styles.vdoBoxHeader
                                                    }
                                                >
                                                    <Typography variant="h3">
                                                        Confirmed Videos
                                                    </Typography>
                                                    <Typography variant="caption">
                                                        {managerSubmissionsData
                                                            ?.data?.data
                                                            ?.confirmed_videos
                                                            ?.total
                                                            ? managerSubmissionsData
                                                                ?.data?.data
                                                                ?.confirmed_videos
                                                                ?.total
                                                            : "-"}
                                                    </Typography>
                                                </Stack>
                                                <TableContainer>
                                                    <Table stickyHeader>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdOne
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Approved
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdTwo
                                                                    }
                                                                >
                                                                    <figure>
                                                                        <LongArrowIcon />
                                                                    </figure>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdThree
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Approved
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdFour
                                                                    }
                                                                    align="right"
                                                                >
                                                                    <Typography variant="body1">
                                                                        {managerSubmissionsData
                                                                            ?.data
                                                                            ?.data
                                                                            ?.confirmed_videos
                                                                            ?.approved_approved
                                                                            ? managerSubmissionsData
                                                                                ?.data
                                                                                ?.data
                                                                                ?.confirmed_videos
                                                                                ?.approved_approved
                                                                            : "-"}
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdOne
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Rejected
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdTwo
                                                                    }
                                                                >
                                                                    <figure>
                                                                        <LongArrowIcon />
                                                                    </figure>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdThree
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Rejected
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdFour
                                                                    }
                                                                    align="right"
                                                                >
                                                                    <Typography variant="body1">
                                                                        {managerSubmissionsData
                                                                            ?.data
                                                                            ?.data
                                                                            ?.confirmed_videos
                                                                            ?.rejected_rejected
                                                                            ? managerSubmissionsData
                                                                                ?.data
                                                                                ?.data
                                                                                ?.confirmed_videos
                                                                                ?.rejected_rejected
                                                                            : "-"}
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdOne
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Website
                                                                        Only
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdTwo
                                                                    }
                                                                >
                                                                    <figure>
                                                                        <LongArrowIcon />
                                                                    </figure>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdThree
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Website
                                                                        Only
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdFour
                                                                    }
                                                                    align="right"
                                                                >
                                                                    <Typography variant="body1">
                                                                        {managerSubmissionsData
                                                                            ?.data
                                                                            ?.data
                                                                            ?.confirmed_videos
                                                                            ?.website_website
                                                                            ? managerSubmissionsData
                                                                                ?.data
                                                                                ?.data
                                                                                ?.confirmed_videos
                                                                                ?.website_website
                                                                            : "-"}
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Box>
                                        </Grid>
                                        <Grid item lg={4}>
                                            <Box
                                                className={`${styles.deniedVdoBox} ${styles.colBox}`}
                                            >
                                                <Stack
                                                    direction={"row"}
                                                    flexWrap={"wrap"}
                                                    alignItems={"center"}
                                                    justifyContent={
                                                        "space-between"
                                                    }
                                                    className={
                                                        styles.vdoBoxHeader
                                                    }
                                                >
                                                    <Typography variant="h3">
                                                        Denied Videos
                                                    </Typography>
                                                    <Typography variant="caption">
                                                        {managerSubmissionsData
                                                            ?.data?.data?.denied
                                                            ?.total
                                                            ? managerSubmissionsData
                                                                ?.data?.data
                                                                ?.denied
                                                                ?.total
                                                            : "-"}
                                                    </Typography>
                                                </Stack>
                                                <TableContainer>
                                                    <Table stickyHeader>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdOne
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Approved
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdTwo
                                                                    }
                                                                >
                                                                    <figure>
                                                                        <LongArrowIcon />
                                                                    </figure>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdThree
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Rejected
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdFour
                                                                    }
                                                                    align="right"
                                                                >
                                                                    <Typography variant="body1">
                                                                        {managerSubmissionsData
                                                                            ?.data
                                                                            ?.data
                                                                            ?.denied
                                                                            ?.approved_website
                                                                            ? managerSubmissionsData
                                                                                ?.data
                                                                                ?.data
                                                                                ?.denied
                                                                                ?.approved_website
                                                                            : "-"}
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdOne
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Approved
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdTwo
                                                                    }
                                                                >
                                                                    <figure>
                                                                        <LongArrowIcon />
                                                                    </figure>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdThree
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Website
                                                                        Only
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdFour
                                                                    }
                                                                    align="right"
                                                                >
                                                                    <Typography variant="body1">
                                                                        {managerSubmissionsData
                                                                            ?.data
                                                                            ?.data
                                                                            ?.denied
                                                                            ?.approved_website
                                                                            ? managerSubmissionsData
                                                                                ?.data
                                                                                ?.data
                                                                                ?.denied
                                                                                ?.approved_website
                                                                            : "-"}
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdOne
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Rejected
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdTwo
                                                                    }
                                                                >
                                                                    <figure>
                                                                        <LongArrowIcon />
                                                                    </figure>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdThree
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Approved
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdFour
                                                                    }
                                                                    align="right"
                                                                >
                                                                    <Typography variant="body1">
                                                                        {managerSubmissionsData
                                                                            ?.data
                                                                            ?.data
                                                                            ?.denied
                                                                            ?.rejected_approved
                                                                            ? managerSubmissionsData
                                                                                ?.data
                                                                                ?.data
                                                                                ?.denied
                                                                                ?.rejected_approved
                                                                            : "-"}
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdOne
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Rejected
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdTwo
                                                                    }
                                                                >
                                                                    <figure>
                                                                        <LongArrowIcon />
                                                                    </figure>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdThree
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Website
                                                                        Only
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdFour
                                                                    }
                                                                    align="right"
                                                                >
                                                                    <Typography variant="body1">
                                                                        {managerSubmissionsData
                                                                            ?.data
                                                                            ?.data
                                                                            ?.denied
                                                                            ?.rejected_website
                                                                            ? managerSubmissionsData
                                                                                ?.data
                                                                                ?.data
                                                                                ?.denied
                                                                                ?.rejected_website
                                                                            : "-"}
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdOne
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Website
                                                                        Only
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdTwo
                                                                    }
                                                                >
                                                                    <figure>
                                                                        <LongArrowIcon />
                                                                    </figure>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdThree
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Approved
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdFour
                                                                    }
                                                                    align="right"
                                                                >
                                                                    <Typography variant="body1">
                                                                        {managerSubmissionsData
                                                                            ?.data
                                                                            ?.data
                                                                            ?.denied
                                                                            ?.website_approved
                                                                            ? managerSubmissionsData
                                                                                ?.data
                                                                                ?.data
                                                                                ?.denied
                                                                                ?.website_approved
                                                                            : "-"}
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdOne
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Website
                                                                        Only
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdTwo
                                                                    }
                                                                >
                                                                    <figure>
                                                                        <LongArrowIcon />
                                                                    </figure>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdOne
                                                                    }
                                                                >
                                                                    <Typography variant="body1">
                                                                        Rejected
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    className={
                                                                        styles.tdFour
                                                                    }
                                                                    align="right"
                                                                >
                                                                    <Typography variant="body1">
                                                                        {managerSubmissionsData
                                                                            ?.data
                                                                            ?.data
                                                                            ?.denied
                                                                            ?.website_rejected
                                                                            ? managerSubmissionsData
                                                                                ?.data
                                                                                ?.data
                                                                                ?.denied
                                                                                ?.website_rejected
                                                                            : "-"}
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </PerfectScrollbar>
                        </Paper>
                    </CustomTabPanel>
                </Box>
            </ManagerDashboardWapper>
        </>
    );
}
